import { createGetAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

const { useGet: useReviewStats } = createGetAPI({
  getURL: (_, query) =>
    `${BASE_URL}/teacher-classroom-reviews/stats/?${stringify(query)}`,
});

export { useReviewStats };
